import React, { Component } from "react";
import { Link } from "react-router-dom";
import Masonry from "react-masonry-component";
import SimpleReactLightbox, {
	SRLWrapper,
	useLightbox,
} from "simple-react-lightbox";

// import PortDelivery1 from "../../images/achievements/StudentDelivery2025Term2_1.jpg";
// import PortDelivery2 from "../../images/achievements/StudentDelivery2025Term2_2.jpg";
// import PortDelivery3 from "../../images/achievements/StudentDelivery2025Term2_3.jpg";
// import PortDelivery4 from "../../images/achievements/StudentDelivery2025Term2_4.jpg";
// import PortDelivery5 from "../../images/achievements/StudentDelivery2025Term2_5.jpg";

import { withTranslation } from "react-i18next";

// import i18next from "i18next";


// Magnific Anchor
const MagnificAnchor = (props) => {
	const { openLightbox } = useLightbox();

	return (
		<Link
			to={"#"}
			onClick={() => openLightbox(props.imageToOpen)}
			className="magnific-anchor"
		>
			<i className="ti-search"></i>
		</Link>
	);
};

const options = {
	settings: {
		overlayColor: "rgba(0,0,0,0.9)",
		backgroundColor: "#f7b205",
		slideAnimationType: "slide",
	},
	buttons: {
		backgroundColor: "#f7b205",
		iconColor: "rgba(255, 255, 255, 1)",
		showAutoplayButton: false,
		showDownloadButton: false,
	},
	caption: {
		captionColor: "#a6cfa5",
		captionFontFamily: "Raleway, sans-serif",
		captionFontWeight: "300",
		captionTextTransform: "uppercase",
	},
};


const context = require.context(
  "../../images/achievements",
  false,
  /img_\d+\.jpg$/
);

const imagesForTag = context
  .keys()
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
  .map(context);

// const FilterList = ({ dataFilter, defaultTag, activeFilter }) => {
// 	return (
// 		<li
// 			className={`${activeFilter ? "btn active" : "btn"}`}
// 			onClick={() => defaultTag(dataFilter)}
// 		>
// 			<Link to={"#"}>{dataFilter}</Link>
// 		</li>
// 	);
// };
// const TagDescriptionList = [
// 	{
// 		tag: "Achievements_Photos_Achievement_AIO",
// 		title: "Achievement_AIO_Title",
// 		description: "Achievement_AIO_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Achievement_YICT",
// 		title: "Achievement_YoungICT_Title",
// 		description: "Achievement_YoungICT_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Achievement_ICAS",
// 		title: "Achievement_ICAS_Title",
// 		description: "Achievement_ICAS_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Achievement_FLL",
// 		title: "Achievement_Lego_Title",
// 		description: "Achievement_Lego_description_fll",
// 	},
// 	{
// 		tag: "Achievements_Photos_Achievement_ROBOCUP",
// 		description: "Achievement_Lego_description_robocup",
// 	},
// 	{
// 		tag: "Achievements_Photos_Achievement_Bebras",
// 		title: "Achievement_Bebras_Title",
// 		description: "Achievement_Bebras_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Community_GiftedChild",
// 		title: "Community_GiftedChild_Title",
// 		description: "Community_GiftedChild_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Community_Digido_2023",
// 		title: "Community_Digido_Title_2023",
// 		description: "Community_Digido_2023_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Community_Digido_2022",
// 		title: "Community_Digido_Title_2022",
// 		description: "Community_Digido_2022_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_ClassEngagement_2025_Term2",
// 		title: "ClassEngagement_Title_2025_Term2",
// 		description: "ClassEngagement_description_2025_Term2",
// 	},

// 	{
// 		tag: "Achievements_Photos_ClassEngagement_2023",
// 		title: "ClassEngagement_Title_2023",
// 		description: "ClassEngagement_description_2023",
// 	},
// 	{
// 		tag: "Achievements_Photos_Award_Ceremony_2023",
// 		title: "Award_Ceremony_2023_Title",
// 		description: "Award_Ceremony_2023_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Award_Ceremony_2024_Speech",
// 		title: "Award_Ceremony_2024_Title",
// 		description: "Award_Ceremony_2024_Speech_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Award_Ceremony_2024_PanelDiscussion",
// 		description: "Award_Ceremony_2024_PanelDiscussion_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Award_Ceremony_2024_AwardCeremony",
// 		description: "Award_Ceremony_2024_AwardCeremony_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Award_Ceremony_2024_Story",
// 		description: "Award_Ceremony_2024_Story_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_Award_Ceremony_2024_LuckyDraw",
// 		description: "Award_Ceremony_2024_LuckyDraw_description",
// 	},
// 	{
// 		tag: "Achievements_Photos_IOAI_2024_Train_AIML",
// 		title: "Achievements_Photos_IOAI_2024_Train_AIML_Title",
// 		description: "Achievements_Photos_IOAI_2024_Train_AIML_description",
// 		link: "/news-7",
// 	},
// 	{
// 		tag: "Achievements_Photos_IOAI_2024_Camp_AIML",
// 		title: "Achievements_Photos_IOAI_2024_Camp_Title",
// 		description: "Achievements_Photos_IOAI_2024_Camp_description",
// 		link: "/news-7",
// 	},
// 	{
// 		tag: "Achievements_Photos_IOAI_2024_Bulgaria_Team_AIML",
// 		title: "Achievements_Photos_IOAI_2024_bugar_Title",
// 		description: "Bugar_Team_DESC",
// 	},
// 	{
// 		tag: "Achievements_Photos_IOAI_2024_Bulgaria_Activity_AIML",
// 		title: "",
// 		description: "Bugar_Activity_DESC",
// 	},
// 	{
// 		tag: "Achievements_Photos_IOAI_2024_Bulgaria_Conference_Workshop_AIML",
// 		title: "",
// 		description: "Bugar_Conference_Workshop_DESC",
// 	},
// 	{
// 		tag: "Achievements_Photos_IOAI_2024_Bulgaria_Competition_AIML",
// 		title: "",
// 		description: "Bugar_Competiton_DESC",
// 	},
// ];

// const content = [
// 	// Student images 2025 Term 2
// 	{
// 		thumb: PortDelivery1,
// 		LightImg: PortDelivery1,
// 		tag: "Achievements_Photos_ClassEngagement_2025_Term2",
// 		title: "Student Delivery 2025 Term 2 - 1",
// 	},
// 	{
// 		thumb: PortDelivery2,
// 		LightImg: PortDelivery2,
// 		tag: "Achievements_Photos_ClassEngagement_2025_Term2",
// 		title: "Student Delivery 2025 Term 2 - 2",
// 	},
// 	{
// 		thumb: PortDelivery3,
// 		LightImg: PortDelivery3,
// 		tag: "Achievements_Photos_ClassEngagement_2025_Term2",
// 		title: "Student Delivery 2025 Term 2 - 3",
// 	},
// 	{
// 		thumb: PortDelivery4,
// 		LightImg: PortDelivery4,
// 		tag: "Achievements_Photos_ClassEngagement_2025_Term2",
// 		title: "Student Delivery 2025 Term 2 - 4",
// 	},
// 	{
// 		thumb: PortDelivery5,
// 		LightImg: PortDelivery5,
// 		tag: "Achievements_Photos_ClassEngagement_2025_Term2",
// 		title: "Student Delivery 2025 Term 2 - 5",
// 	},
// ];

// // group tags together
// const tags_achievement = [
// 	"Achievements_Photos_Achievement_AIO",
// 	"Achievements_Photos_Achievement_YICT",
// 	"Achievements_Photos_Achievement_ICAS",
// 	"Achievements_Photos_Achievement_FLL",
// 	"Achievements_Photos_Achievement_ROBOCUP",
// 	"Achievements_Photos_Achievement_Bebras",
// ];
// const tags_community = [
// 	"Achievements_Photos_Community_GiftedChild",
// 	"Achievements_Photos_Community_Digido_2023",
// 	"Achievements_Photos_Community_Digido_2022",
// ];
// const tags_award = [
// 	"Achievements_Photos_Award_Ceremony_2024_Speech",
// 	"Achievements_Photos_Award_Ceremony_2024_PanelDiscussion",
// 	"Achievements_Photos_Award_Ceremony_2024_AwardCeremony",
// 	"Achievements_Photos_Award_Ceremony_2024_Story",
// 	"Achievements_Photos_Award_Ceremony_2024_LuckyDraw",
// 	"Achievements_Photos_Award_Ceremony_2023",
// ];
// const tags_classEngagement = [
// 	"Achievements_Photos_ClassEngagement_2025_Term2",
// 	"Achievements_Photos_ClassEngagement_2023",
// ];
// const tags_IOAI = [
// 	"Achievements_Photos_IOAI_2024_Train_AIML",
// 	"Achievements_Photos_IOAI_2024_Camp_AIML",
// 	"Achievements_Photos_IOAI_2024_Bulgaria_Team_AIML",
// 	"Achievements_Photos_IOAI_2024_Bulgaria_Competition_AIML",
// 	"Achievements_Photos_IOAI_2024_Bulgaria_Activity_AIML",
// 	"Achievements_Photos_IOAI_2024_Bulgaria_Conference_Workshop_AIML",
// ];

function MasonryContent() {
	// const [filteredImages, setFilteredImages] = useState([]);
	// const [selectedCategory, setSelectedCategory] = useState(i18next.t("Achievements_Photos_ClassEngagement"));

	// useEffect(() => {
	// 	// let tagsToFilter = [];

	// 	// if (selectedCategory === i18next.t("Achievements_Photos_Achievements")) {
	// 	// 	tagsToFilter = tags_achievement;
	// 	// } else if (selectedCategory === i18next.t("Achievements_Photos_Community")) {
	// 	// 	tagsToFilter = tags_community;
	// 	// } else if (selectedCategory === i18next.t("Achievements_Photos_Award_Ceremony")) {
	// 	// 	tagsToFilter = tags_award;
	// 	// } else if (selectedCategory === i18next.t("Achievements_Photos_ClassEngagement")) {
	// 	// 	tagsToFilter = tags_classEngagement;
	// 	// } else if (selectedCategory === i18next.t("Achievements_Photos_IOAI_2024")) {
	// 	// 	tagsToFilter = tags_IOAI;
	// 	// }

	// 	// setFilteredImages(
	// 	// 	content.filter((image) =>
	// 	// 		tagsToFilter.some((tag) => image.tag.includes(tag))
	// 	// 	)
	// 	// );
	// }, [selectedCategory]);

	// const allTags = [...tags_achievement, ...tags_community, ...tags_award, ...tags_classEngagement, ...tags_IOAI];
	// const imagesForTag = filteredImages.filter((image) => image.tag.includes(tag));

	return (
		<>
			{/* <div className="feature-filters clearfix center m-b40">
				<ul className="filters" data-toggle="buttons">
					<FilterList
						dataFilter={i18next.t("Achievements_Photos_ClassEngagement")}
						defaultTag={setSelectedCategory}
						activeFilter={selectedCategory === i18next.t("Achievements_Photos_ClassEngagement")}
					/>
					<FilterList
						dataFilter={i18next.t("Achievements_Photos_Achievements")}
						defaultTag={setSelectedCategory}
						activeFilter={selectedCategory === i18next.t("Achievements_Photos_Achievements")}
					/>
					<FilterList
						dataFilter={i18next.t("Achievements_Photos_Community")}
						defaultTag={setSelectedCategory}
						activeFilter={selectedCategory === i18next.t("Achievements_Photos_Community")}
					/>
					<FilterList
						dataFilter={i18next.t("Achievements_Photos_Award_Ceremony")}
						defaultTag={setSelectedCategory}
						activeFilter={selectedCategory === i18next.t("Achievements_Photos_Award_Ceremony")}
					/>
					<FilterList
						dataFilter={i18next.t("Achievements_Photos_IOAI_2024")}
						defaultTag={setSelectedCategory}
						activeFilter={selectedCategory === i18next.t("Achievements_Photos_IOAI_2024")}
					/>
				</ul>
			</div> */}

			<div>
				<SimpleReactLightbox>
					<SRLWrapper options={options}>
						<Masonry className="ttr-gallery-listing">
							{imagesForTag.map((item, index) => (
								<div
									className="action-card col-lg-3 col-md-4 col-sm-6"
									key={index}
								>
									<div className="ttr-box achievements-bx">
										<div className="ttr-media media-ov2 media-effect m-b20">
											<img alt="" src={item} />
											<div className="ov-box">
												<div className="overlay-icon align-m">
													<MagnificAnchor imageToOpen={index} />
												</div>
											</div>
										</div>
									</div>
								</div>
							))}
						</Masonry>
					</SRLWrapper>
				</SimpleReactLightbox>

				{/* {allTags.map((tag) => {
					const imagesForTag = filteredImages.filter((image) => image.tag.includes(tag));

					// Find titles and descriptions
					const tagData = TagDescriptionList.find(
						(item) => item.tag === tag
					);
					const tagTitle = tagData?.title;
					const tagDescription = tagData?.description;
					const tagLink = tagData?.link;

					if (imagesForTag.length === 0) {
						return null;
					}
					return (
						<div key={tag}>
							<h3>{i18next.t(tagTitle)}</h3>
							<p>
								{i18next.t(tagDescription)}
								{tagLink && (
									<>
										<a href={tagLink} target="_blank" rel="noreferrer">
											here.
										</a>
									</>
								)}
							</p>
							<SimpleReactLightbox>
								<SRLWrapper options={options}>
									<Masonry className="ttr-gallery-listing">
										{imagesForTag.map((item, index) => (
											<div
												className="action-card col-lg-3 col-md-4 col-sm-6"
												key={index}
											>
												<div className="ttr-box achievements-bx">
													<div className="ttr-media media-ov2 media-effect m-b20">
														<img alt="" src={item.thumb} />
														<div className="ov-box">
															<div className="overlay-icon align-m">
																<MagnificAnchor imageToOpen={index} />
															</div>
															<div className="achievements-info-bx">
																<h4>{item.title}</h4>
															</div>
														</div>
													</div>
												</div>
											</div>
										))}
									</Masonry>
								</SRLWrapper>
							</SimpleReactLightbox>
						</div>
					);
				})} */}
			</div>
		</>
	);
}



class achievementsContent extends Component {
	componentDidMount() {

	}
	render() {
		return (
			<>
				<MasonryContent />
			</>
		);
	}
}

export default withTranslation()(achievementsContent);